import React, { useState } from "react";

import styles from "./CardItem.module.css";

//components
import helper from "../../../core/helper/Helper";
import { ProductDetailDialog } from "../../Dialog";
//ui
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import Rating from "@material-ui/lab/Rating";
import { RouterName } from "shared/RouterName";
import toVND from "shared/func/toVND";
import { useDispatch } from "react-redux";
import { fetchAddToCartInLocalStorage } from "redux/ActionCreators/CartActionCreators";
import MessageIcon from "@material-ui/icons/Message";

const CardItem = (props) => {
  const {
    id,
    imgPath,
    title,
    price,
    priceDiscount,
    discount,
    rating,
    promotion,
  } = props;

  const [openDetailProduct, setOpenDetailProduct] = useState(false);
  const dispatch = useDispatch();

  const handelGoToDetailItem = () => {
    helper.push(`${RouterName.ProductDetail.url}/${id}`);
  };

  const handleCloseDetailProduct = () => {
    setOpenDetailProduct(false);
  };

  const handelOpenProductDetail = () => {
    setOpenDetailProduct(true);
  };

  const handleAddShoppingCart = () => {
    dispatch(
      fetchAddToCartInLocalStorage(
        id,
        title,
        priceDiscount ? priceDiscount : price,
        imgPath
      )
    );
    handleCloseDetailProduct();
  };

  return (
    <Card className={styles.container}>
      <ProductDetailDialog
        id={id}
        open={openDetailProduct}
        onClose={handleCloseDetailProduct}
        onAddToShoppingCart={handleAddShoppingCart}
      />
      <CardActionArea onClick={handelGoToDetailItem}>
        <CardMedia
          className={styles.media}
          image={imgPath}
          title="Contemplative Reptile"
        />
        <CardContent>
          <Typography variant="subtitle2" gutterBottom className={styles.title}>
            {title.length > 58 ? `${title.slice(0, 58)}...` : title}
          </Typography>

          <Rating value={rating} size="small" readOnly />
          <Typography
            variant="body1"
            color="textSecondary"
            component="p"
            className={styles.price_last}
          >
            {!price
              ? "Liên hệ với chúng tôi!"
              : priceDiscount
              ? toVND(priceDiscount)
              : toVND(price)}
          </Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            className={styles.price_first}
          >
            {priceDiscount ? toVND(price) : null}
          </Typography>

          <Typography
            variant="overline"
            display="inline"
            gutterBottom
            className={styles.discount}
          >
            {priceDiscount ? discount : null}
          </Typography>
          {promotion && <div className={styles.sale_container}>Sale</div>}
        </CardContent>
      </CardActionArea>
      <CardActions className={styles.btns_group}>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          startIcon={<RemoveRedEyeIcon />}
          className={styles.btn_action}
          onClick={handelOpenProductDetail}
        >
          Chi Tiết
        </Button>
        {price ? (
          <Button
            size="small"
            variant="contained"
            color="primary"
            startIcon={<AddShoppingCartIcon />}
            className={styles.btn_action}
            onClick={handleAddShoppingCart}
          >
            Mua Ngay
          </Button>
        ) : (
          <Button
            size="small"
            variant="contained"
            color="primary"
            startIcon={<MessageIcon />}
            className={styles.btn_action}
            href={process.env.REACT_APP_ADMIN_MESSENGER}
            target="_blank"
          >
            Liên hệ
          </Button>
        )}
      </CardActions>
    </Card>
  );
};
export default CardItem;
